// Development API URI
// export const URI = "http://localhost:5000";
export const URI = "https://sptapiservice.evershinetechsolutions.com/API";

// Production API URI
// export const URI = "https://savepertrip.in";
